import {React,useEffect,useState} from "react";
import { Disclosure, Transition } from "@headlessui/react";
import styles from "./index.module.css";
import { NavLink, useLocation } from "react-router-dom";
import { Tooltip } from "antd";
import { RiHome6Line } from "react-icons/ri";
import { TiArrowSortedDown } from "react-icons/ti";
import { SiPlanet, SiSuperuser } from "react-icons/si";
import { MdEventAvailable, MdOutlineEmojiEvents, MdOutlineEventAvailable } from "react-icons/md";
import { LuUser } from "react-icons/lu";
import { CiSettings } from "react-icons/ci";
import { LiaHistorySolid } from "react-icons/lia";
import environment from '../../../environment';
import ApiClient from '../../../methods/api/apiClient';
import { MdGroups } from "react-icons/md";
import { FaHandshake } from "react-icons/fa";
import { MdFeedback, MdPersonOff } from "react-icons/md";

const Html = ({ ListItemLink, tabclass, isAllow, route, isOpen,user }) => {
  // cw: debugging why GLs only see Plan in main menu
  // console.log('=== SIDEBAR DEBUG ===');
  // console.log('user?.planId:', user?.planId);
  // console.log('user?.customerRole?.name:', user?.customerRole?.name);
  // console.log('user?.customerRole?._id:', user?.customerRole?._id);
  // console.log('environment?.glRoleId:', environment?.glRoleId);
  
  // const condition1 = !user?.planId;
  // const condition2 = user?.customerRole?.name === "Group Leader";
  // const condition3 = user?.customerRole?._id === environment?.glRoleId;
  
  // console.log('!user?.planId:', condition1);
  // console.log('name match:', condition2);
  // console.log('id match:', condition3);
  // console.log('overall condition:', condition1 && (condition2 || condition3));
  // console.log('showing Planmenu?', condition1 && (condition2 || condition3));
  // cw: end of debug

  // cw: debug to check permissions of viewing pgs after groups:[] implementation in users table
  // console.log('=== PERMISSION DEBUG ===');
  // console.log('user:', user);
  // console.log('user.customerRole:', user?.customerRole);
  // console.log('user.customerRole.permissions:', user?.customerRole?.permissions);
  // console.log('isAllow("readMembers"):', isAllow('readMembers'));
  // console.log('isAllow("readEvents"):', isAllow('readEvents'));
  
  const [activeplan, setActiveplan] = useState()
  //const [connectMeetLabel, setConnectMeetLabel] = useState('ConnectMeet');
  //const [labelLoaded, setLabelLoaded] = useState(false);
  const connectMeetLabel = user?.connectMeetLabel || 'ConnectMeet';
  const testimonialLabel = user?.testimonialLabel || 'Thank Yous';
  const labelsReady = !!user?.connectMeetLabel && !!user?.testimonialLabel;
  const location = useLocation();

  const collapsedTextStyle = (name) => {
    if (!isOpen) return {};
    const longest = name.split(/\s+/).reduce((max, w) => Math.max(max, w.length), 0);
    let fontSize = 7;
    if (longest > 13) fontSize = 4.5;
    else if (longest > 10) fontSize = 5.5;
    return { fontSize: `${fontSize}px`, lineHeight: `${fontSize + 2}px` };
  };

  const menus=[
    {
      name:'Main Menu',
    },
    {
      name:'Dashboard',
      icon:<RiHome6Line className="text-[#fff] shrink-0 text-lg" />,
      url:'/dashboard',
      key:'readDashboard',
    },
    // {
    //   name:'Assign Members',
    //   icon:<SiSuperuser className="text-[#fff] shrink-0 text-lg" />      ,
    //   url:'/assign-member',
    //   key:'readMembers',
    // },
    {
      name:'My Groups',
      icon:<MdGroups className="text-[#fff] shrink-0 text-lg" />      ,
      url:'/my-groups',
      key:'',
    },
    {
      name:'Members',
      icon:<LuUser className="text-[#fff] shrink-0 text-lg" />      ,
      url:'/members',
      key:'',
    },
    {
      name:'Events',
      icon:<MdOutlineEmojiEvents className="text-[#fff] shrink-0 text-lg" />      ,
      url:'/event',
      key:'readEvents',
    },
    // {
    //   name:'Plans',
    //   icon:<SiPlanet className="text-[#fff] shrink-0 text-lg" />      ,
    //   url:'/plan',
    //   key:'',
    // },
    {
      name:'Settings',
      icon:<CiSettings className="text-[#fff] shrink-0 text-lg" />      ,
      url:'/setting',
      key:'readMembers',
    },
    {
      name:'History', 
      icon:<LiaHistorySolid className="text-[#fff] shrink-0 text-lg" />      ,
      url:'/history',
      key:'',
    },
    ...(labelsReady && environment.thankYouRoleIds?.includes(user?.customerRole?._id) ? [{
      name: `${testimonialLabel} Group`,
      icon:<FaHandshake className="text-[#fff] shrink-0 text-lg" />,
      url:'/testimonials',
      key:'readEvents',
    }] : []),
    ...(labelsReady ? [{
      name: `${testimonialLabel} Individual`,
      icon:<FaHandshake className="text-[#fff] shrink-0 text-lg" />,
      url:'/testimonials-individual',
      key:'readEvents',
    }] : []),
    // cw: {connectMeetLabel} Request page hidden from the menu (route is disabled; page was view-only).
    // ...(labelsReady ? [{
    //   name: `${connectMeetLabel} Request`,
    //   icon:<MdGroups className="text-[#fff] shrink-0 text-lg" />,
    //   url:'/connectMeetRequest',
    //   key:'',
    // }] : []),
    {
      name: 'Already Connected',
      icon:<MdPersonOff className="text-[#fff] shrink-0 text-lg" />,
      url:'/already-connected',
      key:'',
    },
    {
      name: 'Leave Feedback',
      icon:<MdFeedback className="text-[#fff] shrink-0 text-lg" />,
      url:'#feature-request',
      key:'',
      onClick: true,
      onClickHandler: () => {
        if (!window.ATL_JQ) {
          const script = document.createElement('script');
          script.src = 'https://tech-exec.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/150dpd/b/0/c95134bc67d3a521bb3f4331beb9b804/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector.js?locale=en-US&amp;collectorId=13813273';
          script.onload = () => {
            window.ATL_JQ && window.ATL_JQ.IssueDialog && new window.ATL_JQ.IssueDialog({
              collectorId: '13813273',
              triggerPosition: 'CUSTOM',
              baseUrl: 'https://tech-exec.atlassian.net'
            }).show();
          };
          document.body.appendChild(script);
        } else {
          new window.ATL_JQ.IssueDialog({
            collectorId: '13813273',
            triggerPosition: 'CUSTOM',
            baseUrl: 'https://tech-exec.atlassian.net'
          }).show();
        }
      },
    },
    // ...(labelLoaded ? [{
    //   name: `${connectMeetLabel} Request`,
    //   icon:<MdGroups className="text-[#fff] shrink-0 text-lg" />,
    //   url:'/connectMeetRequest',
    //   key:'',
    // }] : [])
  ]
  const Planmenu=[
    {
      name:'Main Menu',
    },
    {
      name:'Plans',
      icon:<SiPlanet className="text-[#fff] shrink-0 text-lg" />      ,
      url:'/plan',
      key:'',
    },
  
    
  ]
  return (
    <>
      <div className={`px-[8px] ${isOpen && styles.sm_sidebar}`} component="siderbar">
        <ul className="space-y-2 px-2">
          {false ?(
            Planmenu.map((itm) => {
              return (
                <>
                  {itm.name === null ? null : itm.icon ? (
                    <>
                      <li>
                        {itm.menu ? (
                          <>
                            <Disclosure as="div" defaultOpen={tabclass(itm.tab)}>
                              {({ open }) => (
                                <>
                                  <tooltip placement="right" title={itm.name}>
                                    <Disclosure.Button className="w-full p-2.5 rounded-md flex items-center justify-between text-[#4A545E]  hover:!text-[#5577FF] gap-[12px] hover:bg-[#5577FF]/10 transition-all duration-300">
                                      <span className="text-sm font-normal text-inherit flex items-center gap-[12px] crm">
                                        {itm.icon}
                                        <span className=" text-inherit leading-none sidebar_text" style={collapsedTextStyle(itm.name)}> {itm.name}</span>
                                      </span>
                                      <TiArrowSortedDown
                                        className={`${open ? "" : "-rotate-90 transform"
                                          } h-4 w-4 transition-all duration-500  text-[#7E8B99]`}
                                      />
                                    </Disclosure.Button>
                                  </tooltip>
                                  <Transition
                                    enter="transition duration-300 ease-in-out"
                                    enterFrom="transform scale-95 opacity-0"
                                    enterTo="transform scale-300 opacity-300"
                                    leave="transition duration-300 ease-in-out"
                                    leaveFrom="transform scale-300 opacity-300"
                                    leaveTo="transform scale-95 opacity-0">
                                    <Disclosure.Panel className="pl-[30px] mt-[4px] ">
                                      <ul className="space-y-2">
                                        {itm.menu.map((sitm) => {
                                          return (
                                            <>
                                              {isAllow(sitm.key) ? (
                                                <li>
                                                  {" "}
                                                  <NavLink
                                                    className={(isActive) =>
                                                      "p-2.5 rounded-md block text-sm font-normal text-[#4A545E] cursor-pointer hover:!text-[#5577FF] hover:bg-[#5577FF]/10 !no-underline transition-all " +
                                                      (location?.pathname == sitm.url &&
                                                        " !text-[#5577FF] !bg-[#5577FF]/10 !font-medium")
                                                    }
                                                    to={sitm.url}>
                                                    <span className="text-inherit leading-none sidebar_text" style={collapsedTextStyle(sitm.name)} title={sitm.name}> {sitm.name}</span>
                                                  </NavLink>
                                                </li>
                                              ) : null}
                                            </>
                                          );
                                        })}
                                      </ul>
                                    </Disclosure.Panel>
                                  </Transition>
                                </>
                              )}
                            </Disclosure>
                          </>
                        ) : (
                          <>
                            {isAllow(itm.key) ? (
                              <>
                                <tooltip placement="top" color="#ef7a2b" title={itm.name}>
                                  <NavLink
                                    to={itm.url}
                                    className={(isActive) =>
                                      "p-2.5 rounded-md flex items-center gap-[12px] text-sm font-normal text-[#fff] hover:!text-[#fff] hover:bg-[#00b884]/10 !no-underline transition-all " +
                                      (location?.pathname == itm.url && " !text-[#fff] !bg-[#ef7a2b] !font-medium")
                                    }>
                                    {itm.icon}
                                    <span className="text-inherit leading-none sidebar_text" style={collapsedTextStyle(itm.name)}>{itm.name}</span>
                                  </NavLink>
                                </tooltip>
                              </>
                            ) : (
                              <></>
                            )}
                          </>
                        )}
                      </li>
                    </>
                  ) : (
                    <>
                      <li>
                        <h6
                          className={`${isOpen ? "py-[12px] text-center" : "p-[12px] text-center text-md"
                            } text-xs font-medium text-[#7E8B99] mt-[12px]`}>
                          <span className=" sidebar_text text-center"> {itm.name} </span>
                        </h6>
                      </li>
                    </>
                  )}
                </>
              );
            })
          ) :(
            menus.map((itm) => {
              return (
                <>
                  {itm.icon ? (
                    <>
                      <li>
                        {itm.menu ? (
                          <>
                            <Disclosure as="div" defaultOpen={tabclass(itm.tab)}>
                              {({ open }) => (
                                <>
                                  <tooltip placement="right" title={itm.name}>
                                    <Disclosure.Button className="w-full p-2.5 rounded-md flex items-center justify-between text-[#4A545E]  hover:!text-[#5577FF] gap-[12px] hover:bg-[#5577FF]/10 transition-all duration-300">
                                      <span className="text-sm font-normal text-inherit flex items-center gap-[12px] crm">
                                        {itm.icon}
                                        <span className=" text-inherit leading-none sidebar_text" style={collapsedTextStyle(itm.name)}> {itm.name}</span>
                                      </span>
                                      <TiArrowSortedDown
                                        className={`${open ? "" : "-rotate-90 transform"
                                          } h-4 w-4 transition-all duration-500  text-[#7E8B99]`}
                                      />
                                    </Disclosure.Button>
                                  </tooltip>
                                  <Transition
                                    enter="transition duration-300 ease-in-out"
                                    enterFrom="transform scale-95 opacity-0"
                                    enterTo="transform scale-300 opacity-300"
                                    leave="transition duration-300 ease-in-out"
                                    leaveFrom="transform scale-300 opacity-300"
                                    leaveTo="transform scale-95 opacity-0">
                                    <Disclosure.Panel className="pl-[30px] mt-[4px] ">
                                      <ul className="space-y-2">
                                        {itm.menu.map((sitm) => {
                                          return (
                                            <>
                                              {isAllow(sitm.key) ? (
                                                <li>
                                                  {" "}
                                                  <NavLink
                                                    className={(isActive) =>
                                                      "p-2.5 rounded-md block text-sm font-normal text-[#4A545E] cursor-pointer hover:!text-[#5577FF] hover:bg-[#5577FF]/10 !no-underline transition-all " +
                                                      (location?.pathname == sitm.url &&
                                                        " !text-[#5577FF] !bg-[#5577FF]/10 !font-medium")
                                                    }
                                                    to={sitm.url}>
                                                    <span className="text-inherit leading-none sidebar_text" style={collapsedTextStyle(sitm.name)} title={sitm.name}> {sitm.name}</span>
                                                  </NavLink>
                                                </li>
                                              ) : null}
                                            </>
                                          );
                                        })}
                                      </ul>
                                    </Disclosure.Panel>
                                  </Transition>
                                </>
                              )}
                            </Disclosure>
                          </>
                        ) : (
                          <>
                            {isAllow(itm.key) ? (
                              <>
                                <tooltip placement="top" color="#ef7a2b" title={itm.name}>
                                {itm.onClick ? (
                                    <a href="#"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        if (itm.onClickHandler) itm.onClickHandler();
                                      }}
                                      className="p-2.5 rounded-md flex items-center gap-[12px] text-sm font-normal text-[#fff] hover:!text-[#fff] hover:bg-[#00b884]/10 !no-underline transition-all cursor-pointer"
                                    >
                                      {itm.icon}
                                      <span className="text-inherit leading-none sidebar_text" style={collapsedTextStyle(itm.name)}>{itm.name}</span>
                                    </a>
                                  ) : (
                                    <NavLink
                                      to={itm.url}
                                      className={(isActive) =>
                                        "p-2.5 rounded-md flex items-center gap-[12px] text-sm font-normal text-[#fff] hover:!text-[#fff] hover:bg-[#00b884]/10 !no-underline transition-all " +
                                        (location?.pathname == itm.url && " !text-[#fff] !bg-[#ef7a2b] !font-medium")
                                      }>
                                      {itm.icon}
                                      <span className="text-inherit leading-none sidebar_text" style={collapsedTextStyle(itm.name)}>{itm.name}</span>
                                    </NavLink>
                                  )}
                                </tooltip>
                              </>
                            ) : (
                              <></>
                            )}
                          </>
                        )}
                      </li>
                    </>
                  ) : (
                    <>
                      <li>
                        <h6
                          className={`${isOpen ? "py-[12px] text-center" : "p-[12px] text-center text-md"
                            } text-xs font-medium text-[#7E8B99] mt-[12px]`}>
                          <span className=" sidebar_text text-center"> {itm.name} </span>
                        </h6>
                      </li>
                    </>
                  )}
                </>
              );
            })
          ) }
        </ul>
      </div>
    </>
  );
  
}

export default Html